exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.autocomplete-item[data-v-fc0ba61a] {\n  padding: 0.35rem 0;\n}\n.autocomplete-item__title[data-v-fc0ba61a] {\n  font-weight: 500;\n  line-height: 1.2;\n}\n.autocomplete-item__description[data-v-fc0ba61a] {\n  margin-top: 0.15rem;\n  font-size: 0.85rem;\n  line-height: 1.2;\n  color: #7a7a7a;\n}\n", ""]);

// exports
